import BrowserCompatibility from 'helpers/browserCompatibility'
import { useEffect, useState } from 'react'

const useBrowserCompatibility = () => {
  const [isAndroid, setIsAndroid] = useState<boolean>(false)
  const [isIOS, setIsIOS] = useState<boolean>(false)
  const [isMobile, setIsMobile] = useState<boolean>(false)
  const [isTouchEnabled, setIsTouchEnabled] = useState<boolean>(false)
  const [isCompatible, setIsCompatible] = useState<boolean>(true)

  useEffect(() => {
    const handleResize = () => {
      setIsAndroid(BrowserCompatibility.isAndroid(navigator.userAgent))
      setIsIOS(BrowserCompatibility.isIOS(navigator.userAgent))
      setIsMobile(BrowserCompatibility.isMobile(navigator.userAgent))
      setIsCompatible(new BrowserCompatibility().isCompatible(navigator.userAgent))
      setIsTouchEnabled(BrowserCompatibility.isTouchEnabled())
    }

    window.addEventListener('resize', handleResize)

    handleResize()

    return () => window.removeEventListener('resize', handleResize)
  }, [])

  return { isAndroid, isIOS, isMobile, isCompatible, isTouchEnabled }
}

export default useBrowserCompatibility
